import { defaultIconProps, IconProps } from './IconProps';

export const IconControlCenterInfraSet: import('react').FC<IconProps> = ({ size, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 228 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <g filter="url(#filter0_i_1895_33817)">
      <ellipse
        cx="26.8563"
        cy="27.0138"
        rx="26.8563"
        ry="27.0138"
        transform="matrix(0.097356 -0.995235 0.995375 0.0962104 160.393 80.2966)"
        fill="url(#paint0_radial_1895_33817)"
      />
    </g>
    <path
      d="M192.425 30.3159C206.796 31.705 217.304 44.409 215.908 58.6815C214.512 72.9539 201.738 83.4076 187.367 82.0186C172.997 80.6295 162.488 67.9255 163.884 53.653C165.281 39.3806 178.054 28.9269 192.425 30.3159Z"
      stroke="#99B8F7"
      strokeWidth="1.76245"
    />
    <g filter="url(#filter1_d_1895_33817)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M189.838 39.8706C190.605 40.0761 191.064 40.8621 190.862 41.6263L190.497 43.0098L196.052 44.4982L196.417 43.1147C196.619 42.3506 197.404 41.8977 198.171 42.1033C198.938 42.3088 199.396 43.0948 199.194 43.8589L198.828 45.2447C199.488 45.4262 200.061 45.5944 200.551 45.7694C201.315 46.0421 201.997 46.3708 202.58 46.8935C203.486 47.7042 204.112 48.7785 204.37 49.9625C204.536 50.726 204.484 51.4776 204.342 52.2724C204.251 52.7825 204.113 53.3611 203.944 54.0202L205.335 54.3929C206.102 54.5984 206.56 55.3844 206.359 56.1485C206.157 56.9127 205.372 57.3655 204.605 57.16L203.216 56.7879L202.12 60.9385L203.509 61.3106C204.276 61.5161 204.734 62.3022 204.532 63.0663C204.331 63.8304 203.545 64.2833 202.778 64.0777L201.39 63.7056L201.301 64.0395C201.007 65.1532 200.765 66.0724 200.506 66.8047C200.237 67.5653 199.911 68.2435 199.39 68.823C198.583 69.7216 197.509 70.3405 196.324 70.591C195.56 70.7526 194.806 70.6967 194.009 70.5511C193.497 70.4576 192.916 70.3165 192.255 70.1441L191.889 71.5299C191.687 72.294 190.902 72.7469 190.135 72.5414C189.368 72.3359 188.91 71.5498 189.112 70.7857L189.477 69.4022L183.922 67.9137L183.557 69.2973C183.355 70.0614 182.57 70.5142 181.803 70.3087C181.036 70.1032 180.577 69.3172 180.779 68.553L181.145 67.1672C180.486 66.9858 179.912 66.8176 179.422 66.6425C178.658 66.3698 177.977 66.0412 177.393 65.5185C176.488 64.7078 175.862 63.6335 175.604 62.4494C175.438 61.6859 175.49 60.9344 175.631 60.1396C175.767 59.3744 176.01 58.4552 176.304 57.3415L176.392 57.0076L175.004 56.6355C174.237 56.43 173.778 55.644 173.98 54.8799C174.182 54.1158 174.967 53.6629 175.734 53.8684L177.123 54.2405L178.219 50.0899L176.83 49.7178C176.063 49.5123 175.605 48.7262 175.806 47.9621C176.008 47.198 176.793 46.7452 177.56 46.9507L178.951 47.3234C179.13 46.6668 179.295 46.0955 179.468 45.6073C179.737 44.8467 180.062 44.1685 180.583 43.589C181.391 42.6904 182.464 42.0714 183.649 41.8209C184.414 41.6594 185.167 41.7153 185.965 41.8609C186.476 41.9544 187.057 42.0954 187.719 42.2678L188.084 40.882C188.286 40.1179 189.071 39.6651 189.838 39.8706ZM188.1 45.3304C186.91 45.0116 186.101 44.796 185.463 44.6794C184.841 44.5658 184.506 44.5722 184.259 44.6243C183.667 44.7496 183.13 45.059 182.726 45.5083C182.558 45.6951 182.386 45.9811 182.177 46.5743C181.961 47.1834 181.747 47.9887 181.434 49.1738L179.097 58.0286C178.784 59.2137 178.572 60.0196 178.459 60.656C178.349 61.2759 178.357 61.6103 178.41 61.8563C178.539 62.4483 178.852 62.9855 179.305 63.3908C179.493 63.5593 179.781 63.7325 180.376 63.9452C180.988 64.1636 181.796 64.3813 182.986 64.7001L191.874 67.0816C193.063 67.4003 193.872 67.6159 194.511 67.7325C195.133 67.8461 195.468 67.8397 195.714 67.7877C196.307 67.6624 196.843 67.3529 197.247 66.9036C197.415 66.7169 197.587 66.4309 197.797 65.8376C198.012 65.2286 198.226 64.4232 198.539 63.2381L200.877 54.3834C201.19 53.1983 201.401 52.3924 201.515 51.7559C201.625 51.136 201.617 50.8017 201.563 50.5556C201.434 49.9636 201.121 49.4265 200.669 49.0211C200.48 48.8527 200.193 48.6794 199.597 48.4667C198.985 48.2484 198.177 48.0306 196.988 47.7119L188.1 45.3304ZM189.459 50.139L193.436 51.2046C193.787 51.2985 194.128 51.3899 194.411 51.4909C194.722 51.6018 195.08 51.7631 195.407 52.0555C195.859 52.4608 196.172 52.998 196.301 53.59C196.394 54.017 196.357 54.4065 196.299 54.7298C196.247 55.0241 196.157 55.3642 196.065 55.7133L195.019 59.6755C194.927 60.0247 194.837 60.3648 194.737 60.6465C194.628 60.9558 194.468 61.3126 194.177 61.6367C193.773 62.086 193.236 62.3954 192.644 62.5207C192.216 62.611 191.826 62.5716 191.501 62.5124C191.206 62.4585 190.865 62.367 190.514 62.273L186.537 61.2074C186.187 61.1135 185.845 61.0221 185.562 60.9211C185.252 60.8102 184.893 60.6488 184.567 60.3565C184.114 59.9512 183.801 59.414 183.672 58.822C183.579 58.395 183.617 58.0054 183.674 57.6822C183.727 57.3879 183.817 57.0478 183.909 56.6986L184.955 52.7364C185.047 52.3872 185.137 52.0472 185.236 51.7655C185.346 51.4562 185.505 51.0994 185.797 50.7753C186.2 50.326 186.737 50.0165 187.33 49.8913C187.757 49.8009 188.148 49.8403 188.472 49.8996C188.767 49.9535 189.109 50.045 189.459 50.139ZM187.951 52.7148C187.949 52.7204 187.947 52.7263 187.945 52.7326C187.889 52.8903 187.829 53.1145 187.721 53.5248L186.698 57.3987C186.59 57.809 186.531 58.0338 186.502 58.1986C186.501 58.2052 186.5 58.2114 186.499 58.2173C186.504 58.2194 186.51 58.2215 186.517 58.2238C186.675 58.2803 186.9 58.3418 187.312 58.4521L191.2 59.494C191.612 59.6044 191.838 59.6637 192.003 59.6939C192.01 59.6951 192.016 59.6962 192.022 59.6972C192.024 59.6916 192.026 59.6857 192.028 59.6794C192.084 59.5216 192.145 59.2974 192.253 58.8872L193.276 55.0132C193.384 54.603 193.442 54.3782 193.471 54.2134C193.473 54.2068 193.474 54.2006 193.475 54.1947C193.469 54.1926 193.463 54.1904 193.457 54.1882C193.298 54.1316 193.073 54.0702 192.661 53.9598L188.773 52.9179C188.361 52.8076 188.136 52.7483 187.97 52.7181C187.964 52.7169 187.957 52.7158 187.951 52.7148Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter2_i_1895_33817)">
      <ellipse
        cx="18.5325"
        cy="18.6288"
        rx="18.5325"
        ry="18.6288"
        transform="matrix(0.249737 -0.968279 0.969059 0.246963 126.281 36.291)"
        fill="url(#paint1_radial_1895_33817)"
      />
    </g>
    <path
      d="M153.37 5.85576C162.873 8.27748 168.594 17.8949 166.16 27.3301C163.727 36.7652 154.056 42.4601 144.554 40.0384C135.051 37.6167 129.33 27.9992 131.763 18.5641C134.197 9.12898 143.867 3.43404 153.37 5.85576Z"
      stroke="#99B8F7"
      strokeWidth="1.76245"
    />
    <g filter="url(#filter3_d_1895_33817)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.588 27.1259H140.727V30.6733C140.727 30.6734 140.727 30.6734 140.727 30.6735C140.727 31.9796 144.278 33.0384 148.657 33.0384C153.037 33.0384 156.588 31.9796 156.588 30.6735C156.588 30.6734 156.588 30.6734 156.588 30.6733V27.1259Z"
        fill="white"
      />
      <ellipse cx="148.655" cy="27.1252" rx="7.93088" ry="1.97088" fill="#A2C0FC" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.588 21.2124H140.727V24.7595C140.727 24.7597 140.727 24.7598 140.727 24.76C140.727 26.0659 144.278 27.1246 148.657 27.1246C153.037 27.1246 156.588 26.0659 156.588 24.76C156.588 24.7598 156.588 24.7597 156.588 24.7595V21.2124Z"
        fill="white"
      />
      <ellipse cx="148.655" cy="21.2124" rx="7.93088" ry="1.97088" fill="#A2C0FC" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.588 15.3005L140.727 15.3005V18.8481C140.727 18.8483 140.727 18.8484 140.727 18.8486C140.727 20.1548 144.277 21.2137 148.657 21.2137C153.038 21.2137 156.588 20.1548 156.588 18.8486C156.588 18.8484 156.588 18.8483 156.588 18.8481V15.3005Z"
        fill="white"
      />
      <ellipse cx="148.655" cy="15.2999" rx="7.93088" ry="1.97088" fill="#A2C0FC" />
    </g>
    <g filter="url(#filter4_i_1895_33817)">
      <ellipse
        cx="33.3524"
        cy="33.5306"
        rx="33.3524"
        ry="33.5306"
        transform="matrix(-0.246764 -0.969107 0.969747 -0.243987 16.6367 95.8239)"
        fill="url(#paint2_radial_1895_33817)"
      />
    </g>
    <path
      d="M32.91 23.8527C50.4006 19.4521 68.1602 29.9797 72.5844 47.3547C77.0086 64.7298 66.426 82.3882 48.9355 86.7888C31.4449 91.1894 13.6853 80.6618 9.2611 63.2868C4.83689 45.9117 15.4195 28.2533 32.91 23.8527Z"
      stroke="#99B8F7"
      strokeWidth="1.76245"
    />
    <g filter="url(#filter5_d_1895_33817)">
      <path
        d="M19.458 50.9163C18.9477 49.1244 18.6925 48.2285 18.8976 47.4286C19.078 46.7249 19.5001 46.0734 20.1034 45.5672C20.7892 44.9918 21.8169 44.6951 23.8725 44.1016L48.8307 36.8956C50.8863 36.3022 51.9141 36.0054 52.7986 36.1275C53.5765 36.2348 54.2774 36.5622 54.8008 37.0626C55.3958 37.6315 55.6509 38.5275 56.1613 40.3194L56.8903 42.879C57.4007 44.6709 57.6559 45.5668 57.4508 46.3668C57.2703 47.0704 56.8483 47.722 56.245 48.2281C55.5592 48.8035 54.5314 49.1003 52.4758 49.6937L27.5176 56.8997C25.4621 57.4932 24.4343 57.7899 23.5498 57.6679C22.7718 57.5605 22.0709 57.2332 21.5476 56.7327C20.9526 56.1638 20.6974 55.2679 20.1871 53.476L19.458 50.9163Z"
        fill="white"
      />
      <path
        d="M24.2748 67.8281C23.7644 66.0362 23.5093 65.1403 23.7144 64.3403C23.8948 63.6367 24.3169 62.9851 24.9201 62.479C25.6059 61.9036 26.6337 61.6068 28.6893 61.0134L53.6475 53.8074C55.7031 53.2139 56.7309 52.9172 57.6153 53.0392C58.3933 53.1466 59.0942 53.4739 59.6175 53.9744C60.2125 54.5433 60.4677 55.4392 60.9781 57.2311L61.7071 59.7908C62.2174 61.5827 62.4726 62.4786 62.2675 63.2785C62.0871 63.9822 61.665 64.6337 61.0618 65.1399C60.376 65.7153 59.3482 66.012 57.2926 66.6055L32.3344 73.8115C30.2788 74.4049 29.251 74.7017 28.3666 74.5796C27.5886 74.4723 26.8877 74.1449 26.3643 73.6445C25.7694 73.0756 25.5142 72.1796 25.0038 70.3877L24.2748 67.8281Z"
        fill="white"
      />
    </g>
    <ellipse
      cx="2.38829"
      cy="2.37562"
      rx="2.38829"
      ry="2.37562"
      transform="matrix(0.960501 -0.277316 0.273997 0.962011 23.5645 47.9012)"
      fill="#6796F4"
    />
    <ellipse
      cx="2.38829"
      cy="2.37562"
      rx="2.38829"
      ry="2.37562"
      transform="matrix(0.960501 -0.277316 0.273997 0.962011 28.4492 65.0397)"
      fill="#6796F4"
    />
    <defs>
      <filter
        id="filter0_i_1895_33817"
        x="162.879"
        y="29.3109"
        width="54.0352"
        height="53.7126"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="7.0498" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1895_33817" />
      </filter>
      <filter
        id="filter1_d_1895_33817"
        x="166.705"
        y="32.5945"
        width="46.9277"
        height="47.2229"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="3.61328" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.6 0 0 0 0 0.721569 0 0 0 0 0.968627 0 0 0 0.9 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1895_33817" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1895_33817" result="shape" />
      </filter>
      <filter
        id="filter2_i_1895_33817"
        x="130.32"
        y="4.41766"
        width="37.2832"
        height="37.0588"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="7.0498" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1895_33817" />
      </filter>
      <filter
        id="filter3_d_1895_33817"
        x="128.866"
        y="1.47053"
        width="39.5802"
        height="43.4263"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="5.92923" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.340426 0 0 0 0 1 0 0 0 0.4 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1895_33817" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1895_33817" result="shape" />
      </filter>
      <filter
        id="filter4_i_1895_33817"
        x="7.37305"
        y="21.9714"
        width="67.0996"
        height="66.6986"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="7.0498" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1895_33817" />
      </filter>
      <filter
        id="filter5_d_1895_33817"
        x="18.8262"
        y="36.1004"
        width="43.5117"
        height="40.2688"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="1.76245" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.842383 0 0 0 0 0.886927 0 0 0 0 1 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1895_33817" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1895_33817" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_1895_33817"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-31.0622 23.5053) rotate(14.7622) scale(100.3 90.0211)"
      >
        <stop offset="0.42" stopColor="#6695F3" />
        <stop offset="1" stopColor="#D9E4FF" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_1895_33817"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-21.4348 16.2093) rotate(14.7528) scale(69.2103 62.0813)"
      >
        <stop offset="0.42" stopColor="#6695F3" />
        <stop offset="1" stopColor="#D9E4FF" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_1895_33817"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-38.5757 29.1757) rotate(14.7548) scale(124.557 111.742)"
      >
        <stop offset="0.42" stopColor="#6695F3" />
        <stop offset="1" stopColor="#D9E4FF" />
      </radialGradient>
    </defs>
  </svg>
);

IconControlCenterInfraSet.defaultProps = defaultIconProps;
